export default "__VITE_ASSET__42e67b25__"